import styled, { keyframes } from 'styled-components';

export const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const PageWrapper = styled.div`
  padding: 24px;
  max-width: 1200px;
  margin: auto;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: ${fadeIn} 0.6s ease-out;
`;

export const HeaderSection = styled.div`
  flex-shrink: 0;
  margin-bottom: 20px;
`;

export const TableContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.06);
`;

export const CreateButton = styled.button`
  padding: 10px 20px;
  background: linear-gradient(135deg, #007bff, #0056b3);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 12px;
  box-shadow: 0 4px 8px rgba(0, 123, 255, 0.3);
  transition: all 0.3s ease;
  
  &:hover {
    background: linear-gradient(135deg, #0056b3, #007bff);
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(0, 123, 255, 0.4);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

export const Header = styled.h1`
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 20px;
`;

export const Tabs = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
`;

export const TabButton = styled.button<{ active?: boolean }>`
  padding: 10px 20px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  background: ${(p) => (p.active ? 'linear-gradient(135deg, #007bff, #0056b3)' : 'linear-gradient(135deg, #e9ecef, #ced4da)')};
  color: ${(p) => (p.active ? '#fff' : '#333')};
  font-weight: 600;
  box-shadow: ${(p) => (p.active ? '0 4px 8px rgba(0, 123, 255, 0.3)' : '0 2px 4px rgba(0, 0, 0, 0.1)')};
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: ${(p) => (p.active ? '0 6px 12px rgba(0, 123, 255, 0.4)' : '0 4px 8px rgba(0, 0, 0, 0.15)')};
  }
  
  &:active {
    transform: translateY(0);
  }
`;

export const Section = styled.div`
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.06);
`;

export const FormRow = styled.div`
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
`;

export const FormRowGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 16px;
  margin-bottom: 16px;
`;

export const Label = styled.label`
  margin-bottom: 6px;
  font-weight: 700;
  font-size: 14px;
  color: #2c3e50;
  text-transform: uppercase;
  letter-spacing: 0.3px;
`;

export const VocabCount = styled.span`
  font-weight: 600;
  font-size: 14px;
  color: #333;
`;

export const Input = styled.input`
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #ccc;
`;

export const TextArea = styled.textarea`
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #ccc;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  font-size: 14px;
  line-height: 1.6;
`;

export const Select = styled.select`
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #ccc;
`;

export const FileInput = styled.input``;

export const ChooseFileButton = styled.button`
  padding: 8px 16px;
  background: linear-gradient(135deg, #007bff, #0056b3);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  box-shadow: 0 4px 8px rgba(0, 123, 255, 0.3);
  transition: all 0.3s ease;
  
  &:hover {
    background: linear-gradient(135deg, #0056b3, #007bff);
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(0, 123, 255, 0.4);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

export const FileListContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
`;

export const FileListItem = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(102, 126, 234, 0.3);
  transition: all 0.2s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
  }
  
  span {
    font-size: 14px;
    color: #fff;
    font-weight: 500;
    word-break: break-word;
  }
`;

export const FileDownloadButton = styled.button`
  background: rgba(255, 255, 255, 0.95);
  color: #667eea;
  border: none;
  border-radius: 50%;
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  line-height: 1;
  padding: 0;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  
  &:hover {
    background: #fff;
    transform: scale(1.1);
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);
  }
`;

export const FileRemoveButton = styled.button`
  background: rgba(255, 255, 255, 0.95);
  color: #dc3545;
  border: none;
  border-radius: 50%;
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  line-height: 1;
  padding: 0;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  
  &:hover {
    background: #fff;
    transform: scale(1.1);
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);
  }
`;

export const SaveButton = styled.button`
  padding: 12px 24px;
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  margin-top: 10px;
  box-shadow: 0 4px 8px rgba(40, 167, 69, 0.3);
  transition: all 0.3s ease;
  
  &:hover {
    background: linear-gradient(135deg, #20c997 0%, #28a745 100%);
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(40, 167, 69, 0.4);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

export const CancelButton = styled.button`
  padding: 12px 24px;
  background: linear-gradient(135deg, #6c757d 0%, #495057 100%);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  margin-top: 10px;
  margin-left: 10px;
  box-shadow: 0 4px 8px rgba(108, 117, 125, 0.3);
  transition: all 0.3s ease;
  
  &:hover {
    background: linear-gradient(135deg, #495057 0%, #6c757d 100%);
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(108, 117, 125, 0.4);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  
  thead th {
    background-color: #f0f0f0;
    color: #333;
    padding: 12px;
    text-align: left;
    border-bottom: 2px solid #ccc;
    font-weight: 600;
    position: sticky;
    top: 0;
    z-index: 10;
  }
  
  tbody tr:nth-child(odd) {
    background-color: #f0f8ff;
  }
  
  tbody tr:nth-child(even) {
    background-color: white;
  }
  
  tbody td {
    padding: 12px;
    border: 0.5px solid #ccc;
    max-width: 200px;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  
  button {
    margin-right: 8px;
  }
`;

export const FilterTag = styled.div<{ isActive: boolean }>`
  padding: 6px 12px;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  background: ${(p) => 
    p.isActive 
      ? 'linear-gradient(135deg, #007bff, #0056b3)' 
      : 'linear-gradient(135deg, #f8f9fa, #e9ecef)'
  };
  color: ${(p) => (p.isActive ? '#fff' : '#495057')};
  box-shadow: ${(p) => 
    p.isActive 
      ? '0 4px 8px rgba(0, 123, 255, 0.3)' 
      : '0 2px 4px rgba(0, 0, 0, 0.1)'
  };
  transform: ${(p) => (p.isActive ? 'translateY(-2px)' : 'translateY(0)')};
  transition: all 0.3s ease;
  user-select: none;
  
  &:hover {
    background: ${(p) => 
      p.isActive 
        ? 'linear-gradient(135deg, #0056b3, #007bff)' 
        : 'linear-gradient(135deg, #e9ecef, #dee2e6)'
    };
    box-shadow: ${(p) => 
      p.isActive 
        ? '0 6px 12px rgba(0, 123, 255, 0.4)' 
        : '0 4px 8px rgba(0, 0, 0, 0.15)'
    };
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const VocabCopyButton = styled.button`
  background: linear-gradient(135deg, #0066cc 0%, #004d99 100%);
  color: white;
  border: none;
  border-radius: 6px;
  padding: 6px 14px;
  font-size: 12px;
  cursor: pointer;
  font-weight: 600;
  box-shadow: 0 3px 6px rgba(0, 102, 204, 0.3);
  transition: all 0.3s ease;
  
  &:hover {
    background: linear-gradient(135deg, #004d99 0%, #0066cc 100%);
    transform: translateY(-2px);
    box-shadow: 0 5px 10px rgba(0, 102, 204, 0.4);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

export const FileNameSpan = styled.span`
  position: relative;
  font-size: 12px;
  word-break: break-word;
  cursor: default;
  flex: 1;
  min-width: 0;

  /* Tooltip styling with instant display */
  &[title]:hover::after {
    content: attr(title);
    position: absolute;
    bottom: 125%;
    left: 0;
    background-color: rgba(0, 0, 0, 0.9);
    color: white;
    padding: 8px 12px;
    border-radius: 6px;
    white-space: normal;
    max-width: 300px;
    word-wrap: break-word;
    z-index: 1000;
    font-size: 12px;
    line-height: 1.4;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    transition: opacity 0.1s ease;
    pointer-events: none;
  }

  &[title]:hover::before {
    content: '';
    position: absolute;
    bottom: 115%;
    left: 10px;
    border: 6px solid transparent;
    border-top-color: rgba(0, 0, 0, 0.9);
    z-index: 1000;
    transition: opacity 0.1s ease;
  }
`;

export const FileItemBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  background-color: #e7f9f0;
  border-radius: 6px;
  border: 1px solid #b3e6cc;
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const VocabTestBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  background-color: #fff4e6;
  border-radius: 6px;
  border: 1px solid #ffd699;
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0;
  }
`;

// Modal Button Styles
export const WarningButton = styled.button`
  padding: 6px 12px;
  background: linear-gradient(135deg, #17a2b8, #138496);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  box-shadow: 0 4px 8px rgba(23, 162, 184, 0.3);
  transition: all 0.3s ease;

  &:hover {
    background: linear-gradient(135deg, #138496, #17a2b8);
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(23, 162, 184, 0.4);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const DangerButton = styled.button`
  padding: 6px 12px;
  background: linear-gradient(135deg, #dc3545, #c82333);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  box-shadow: 0 4px 8px rgba(220, 53, 69, 0.3);
  transition: all 0.3s ease;

  &:hover {
    background: linear-gradient(135deg, #c82333, #dc3545);
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(220, 53, 69, 0.4);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const PrimaryButton = styled.button`
  padding: 10px 20px;
  background: linear-gradient(135deg, #007bff, #0056b3);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  box-shadow: 0 4px 8px rgba(0, 123, 255, 0.3);
  transition: all 0.3s ease;

  &:hover {
    background: linear-gradient(135deg, #0056b3, #007bff);
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(0, 123, 255, 0.4);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    background: linear-gradient(135deg, #6c757d, #5a6268);
    cursor: not-allowed;
    box-shadow: none;
    transform: none;
  }
`;

export const SecondaryButton = styled.button`
  padding: 10px 20px;
  background: linear-gradient(135deg, #6c757d, #545b62);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  box-shadow: 0 4px 8px rgba(108, 117, 125, 0.3);
  transition: all 0.3s ease;

  &:hover {
    background: linear-gradient(135deg, #545b62, #6c757d);
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(108, 117, 125, 0.4);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const SuccessButton = styled.button`
  padding: 10px 20px;
  background: linear-gradient(135deg, #28a745, #20c997);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  box-shadow: 0 4px 8px rgba(40, 167, 69, 0.3);
  transition: all 0.3s ease;

  &:hover {
    background: linear-gradient(135deg, #20c997, #28a745);
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(40, 167, 69, 0.4);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const InfoButton = styled.button`
  padding: 6px 12px;
  background: linear-gradient(135deg, #17a2b8, #138496);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  box-shadow: 0 4px 8px rgba(23, 162, 184, 0.3);
  transition: all 0.3s ease;

  &:hover {
    background: linear-gradient(135deg, #138496, #17a2b8);
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(23, 162, 184, 0.4);
  }

  &:active {
    transform: translateY(0);
  }
`;
